import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
class StringInterface extends BuiltinInterface {
}
class StringValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'StringConstructor';
    }
}
class StringConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('String', new StringInterface());
    builtins.addValue('String', new StringValue());
    builtins.addInterface('StringConstructor', new StringConstructorInterface());
};

//# sourceMappingURL=index.js.map
